import { render, staticRenderFns } from "./corneaNPJ.vue?vue&type=template&id=f3d679b6&scoped=true&"
import script from "./corneaNPJ.vue?vue&type=script&lang=js&"
export * from "./corneaNPJ.vue?vue&type=script&lang=js&"
import style0 from "./corneaNPJ.vue?vue&type=style&index=0&id=f3d679b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d679b6",
  null
  
)

export default component.exports